type BrandNameProps = {
  className?: string
}

export default function BrandName({ className = '' }: BrandNameProps) {
  return (
    <span className={`font-mono font-bold text-sky-700 dark:text-sky-300 ${className}`.trim()}>
      Ask<span className="ml-[0.15em]">QIEN</span>
    </span>
  )
}
